/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import { getPowerOfAttorneyOverviewSteps } from "../../../services/contractLaw/powerOfAttorneyInformationHelper";
import HighlightBox from "../../Box/HighlightBox/HighlightBox";
import HintBox from "../../Box/HintBox/HintBox";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import FormSubmitProps from "../../../types/FormSubmitProps";
import PowerOfAttorneyNextSteps from "../Common/PowerOfAttorney/PowerOfAttorneyNextSteps";

type PowerOfAttorneyHintBoxProps = {
  product: AbstractCase;
  submitProps: FormSubmitProps;
};

export default function PowerOfAttorneyIntroHintBox({ product, submitProps }: PowerOfAttorneyHintBoxProps) {
  if (submitProps.isMinimal) {
    return null;
  }

  return (
    <HintBox headline={"So geht es weiter"}>
      <PowerOfAttorneyNextSteps bulletPoints={getPowerOfAttorneyOverviewSteps(product)} />
      {product.caseInsurance.iIWPI && (
        <HighlightBox textColor={"defaultText"} headline={""}>
          {product.caseInsurance.deductibleMayApply
            ? `Die ${product.caseInsurance.insurer?.name} übernimmt die Kosten des weiteren Vorgehens gemäß Ihren Versicherungsbedingungen. Eine eventuell anfallende Selbstbeteiligung tragen Sie selbst.`
            : `Sie sind bei der ${product.caseInsurance.insurer?.name} rechtsschutzversichert, daher ist das weitere Vorgehen für Sie komplett kostenlos!`}
        </HighlightBox>
      )}
      {product.caseInsurance.iIWPI === false && product.legalExpenseInsurance && (
        <HighlightBox textColor={"defaultText"} headline={""}>
          Sie haben angegeben, dass Sie bei {product.caseInsurance.insurer?.name} rechtsschutzversichert sind, daher müssen Sie sich über Kosten keinerlei
          Sorgen machen! Wir stellen eine Deckungsanfrage bei Ihrer Versicherung und kümmern uns um alles Weitere bezüglich der Abrechnung.
        </HighlightBox>
      )}
    </HintBox>
  );
}
